export default __webpack_public_path__ + "static/media/logo-symbol.1818c5e3.svg";